import type { ComponentProps } from 'react';

import { Box } from '#/components/Box/Box';

type Props = ComponentProps<typeof Box>;

export function TileBody({ children, ...props }: Props) {
  return (
    <Box
      p={[20, null, null, 40]}
      borderRadius-="0 0 8px 8px"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </Box>
  );
}
